import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../Context/MainContext";
import { formatCurrency } from "../../utils/number.utils";
import PaymentDocTableComponent from "../../Components/PaymentDocTable.component";

const OCsPage = () => {

    const { transactions } = useContext(AppContext);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        if (transactions.length > 0) {
            let tmp = transactions.filter((transaction: any) => transaction.type === 'OC');
            setData(tmp);
        }
    }, [transactions]);

    let columns = [
        { wrap: true, maxWidth: "10%", name: "Fecha", selector: (row: any) => new Date(row.date).toLocaleDateString(), sortable: true, sortFunction: (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime() },
        { wrap: true, maxWidth: "10%", name: "Familia", selector: (row: any) => row.family, sortable: true },
        { wrap: true, maxWidth: "15%", name: "Hoja de control", selector: (row: any) => row.controlSheet ? row.controlSheet.name : "", sortable: true },
        { wrap: true, maxWidth: "10%", name: "O/C", selector: (row: any) => row.rawValue.cabecera.documento.numOc },
        { wrap: true, maxWidth: "15%", name: "Proveedor", selector: (row: any) => row.client, sortable: true },
        { wrap: true, maxWidth: "20%", name: "Descripción", selector: (row: any) => row.description },
        { wrap: true, maxWidth: "10%", name: "Monto", selector: (row: any) => `$${formatCurrency(row.total)}`, sortable: true, sortFunction: (a: any, b: any) => parseInt(a.total) - parseInt(b.total) },
        { wrap: true, maxWidth: "10%", name: "Estado", selector: (row: any) => row.status },
    ];

    return (
        <PaymentDocTableComponent
            title="Ordenes de Compra"
            data={data}
            columns={columns}
        />
    );
}

export default OCsPage;